import React, { useContext, useEffect, useState } from "react";
import { ApiGetCall, ApiGetHeaders, ApiPostCall, ApiPostCallAuthKey } from "../../JS/Connector";
import { CamelCaseWithSpaces, Camelcase, LogInSchoolID, LogInUserID, formatDateToUsaMMDDYYYY, formatDecimal, getTypeWatchDelay, transformNameOfCol, typewatch } from "../../JS/Common";
import TicketDetailsPopup from "../../Components/TicketDetailsPopup";
import { DeviceDetailsPopup } from "../../Components/DeviceDetailsPopup";
import Pagination from "react-js-pagination";
import { useLocation, useNavigate } from "react-router-dom";
import CreateShippingCom from "../../Components/CreateShippingCom";
import CustomizationPopup from "../../Components/CustomizationPopup";
import UserDetailsPopup from "../../Components/UserDetailsPopup";
import Cookies from 'js-cookie';
import PageHead from "../../Components/PageHead";
import Tab from "../../Components/Tab";
import AlertsComp from "../../Components/AlertsComp";
import Deletepopup from "../../Components/Deletepopup";
import Popup from "../../Components/Popup";
import DefaultShipMethod from "../Setting/DefaultShipMethod";
import { ThemeContext, UserContext } from "../../App";
import { useDefaultShipMethodCall } from "../../Hooks";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";

export function ShipDevices() {
    const navigate = useNavigate();
    const location = useLocation();
    const addMoreDeviceBatchId = location.state && location.state.batchid;
    const addMoreDeviceBatchFlag = location.state && location.state.batchflag;
    const addMoreDeviceTrackingNum = location.state && location.state.trackingnum;
    const { UserData } = useContext(UserContext);
    const { copyaccesstype, role, copyrole } = UserData;
    const { state } = useContext(ThemeContext);
    const schoolDetail = state?.ShippingType
    const [AllShipDevices, setAllShipDevices] = useState([]);
    const [AllShipDevicesForOpen, setAllShipDevicesForOpen] = useState([]);
    const [TicketTabs, setTicketTabs] = useState({
        OpenTicketsTab: "",
        AwaitingShipTab: "active",
        sortbykey: "",
        sortbyflag: "desc",
    });
    const [searchString, setSearchString] = useState({
        SearchForOpen: '',
        SearchForAwaitingShip: '',
    })
    const [IsModal, setIsModal] = useState({
        TicketPopup: false,
        DevicePopup: false,
        TicketID: "",
        DeviceID: "",
        createbatch: false,
        ShowCreateBatchButton: false,
    });
    const [loading, setLoading] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const [selectedIdsAll, setSelectedIdsAll] = useState([]);
    const [selectedIdsOpen, setSelectedIdsOpen] = useState([]);
    const [SelectedItems, setSelectedItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = AllShipDevices?.length > 0;
    const showPagination1 = AllShipDevicesForOpen?.length > 0;
    const [totalBatches, setTotalBatches] = useState('')
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [UserModal, setUserModal] = useState(false)
    const [Userid, setUserid] = useState('');
    const [selectAllFlag, setSelectAllFlag] = useState(0);
    const [defaultCarrierPopup, setDefautCarrierPopup] = useState(false);
    const [defaultShipMethod, setDefaultShipMethod] = useState(UserData.defaultShipMethod);
    const effectiveRole = copyrole || role || null;

    var schoolname = Cookies.get('ShipSchoolName')
    if (schoolname) {
        schoolname = decodeURIComponent(schoolname);
    }

    const { DefaultShipMethodCall } = useDefaultShipMethodCall();

    useEffect(() => {
        setDefaultShipMethod(UserData.defaultShipMethod)
    }, [UserData.defaultShipMethod])

    useEffect(() => {
        ApiGetHeaders(14, setColumnNames);
        if (!addMoreDeviceBatchId) {
            if (location.state) {
                navigate(location.pathname, { replace: true });
            }
        }
    }, [TicketTabs.OpenTicketsTab]);

    useEffect(() => {
        if (TicketTabs.OpenTicketsTab == "active") {
            GetTickets(1, searchString.SearchForOpen ? searchString.searchStringSearchForOpen : null, TicketTabs.sortbykey ? TicketTabs.sortbykey : null, false);
        } else {
            GetTickets(2, searchString.SearchForAwaitingShip ? searchString.SearchForAwaitingShip : null, TicketTabs.sortbykey ? TicketTabs.sortbykey : null, false);
        }
    }, [currentPage, LimitForPagination]);
    useEffect(() => {
        if (selectAllFlag) {
            if (TicketTabs.AwaitingShipTab == "active") {
                setSelectedIdsAll(AllShipDevices.map((item) => item.id));
            } else {
                setSelectedIdsOpen(AllShipDevicesForOpen.map((item) => item.id));
            }
        }
    }, [AllShipDevices, AllShipDevicesForOpen, selectAllFlag]);

    useEffect(() => {
        const selectedArray = [
            ...selectedIdsAll.map((id) => ({ id })),
            ...selectedIdsOpen.map((id) => ({ id })),
        ];
        const idAndSubtotalArray = selectedArray.map(({ id }) => ({ id: id }));
        setSelectedItems(idAndSubtotalArray);
        if (idAndSubtotalArray.length === 0 && selectedIdsOpen.length === 0) {
            setIsModal({ ...IsModal, ShowCreateBatchButton: false });
        }
        const sumOfTotalBatches = selectedIdsAll.length + selectedIdsOpen.length;
        setTotalBatches(sumOfTotalBatches);
    }, [selectedIdsAll, selectedIdsOpen])

    async function GetTickets(Schoolflag, searchstring, sortbykey, toogleSort) {
        if (!searchstring) searchstring = null;
        if (sortbykey && toogleSort) TicketTabs.sortbyflag = TicketTabs.sortbyflag == "asc" ? "desc" : "asc";
        setTicketTabs({ ...TicketTabs, sortbykey: sortbykey })
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/shipping/tickets?schoolId=${LogInSchoolID}&flag=${Schoolflag}&search=${searchstring}&sortBy=${sortbykey}&sortByOrder=${TicketTabs.sortbyflag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false)
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs?.tickets?.total)
                    if (responseRs?.tickets?.data?.length != 0) {
                        if (Schoolflag == 2) {
                            setAllShipDevices(responseRs?.tickets?.data);
                        } else if (Schoolflag == 1) {
                            setAllShipDevicesForOpen(responseRs?.tickets?.data);
                        }
                    } else {
                        setAllShipDevices([]);
                        setAllShipDevicesForOpen([]);
                    }
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }

    function handleHeaderCheckboxChange(e, ticketFlag) {
        setIsModal({ ...IsModal, ShowCreateBatchButton: true });
        const isChecked = e.target.checked;
        if (ticketFlag === "all") {
            setSelectedIdsAll(
                isChecked ? AllShipDevices.map((item) => item.id) : []
            );
        } else if (ticketFlag === "open") {
            setSelectedIdsOpen(
                isChecked ? AllShipDevicesForOpen.map((item) => item.id) : []
            );
        }
    };
    function handleCheckboxChange(e, ticketFlag, ticketID) {
        const isChecked = e.target.checked;
        setIsModal({ ...IsModal, ShowCreateBatchButton: true });
        if (ticketFlag === "all") {
            setSelectedIdsAll((prevIds) => {
                if (isChecked) {
                    return [...prevIds, ticketID];
                } else {
                    return prevIds.filter((id) => id !== ticketID);
                }
            });
        } else if (ticketFlag === "open") {
            setSelectedIdsOpen((prevIds) => {
                if (isChecked) {
                    return [...prevIds, ticketID];
                } else {
                    return prevIds.filter((id) => id !== ticketID);
                }
            });
        }
    }
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "ticket_num": (
                <span className='py-12 cursor-pointer' onClick={(e) =>
                    setIsModal({ ...IsModal, TicketPopup: true, TicketID: item.id, DeviceID: item.inventory_id })}>
                    <u>{item.ticket_num}</u>
                </span>
            ),
            "Serial_number": (
                <span className='py-12 cursor-pointer' onClick={(e) =>
                    setIsModal({ ...IsModal, DevicePopup: true, TicketID: item.id, DeviceID: item.inventory_id })}>
                    <u>{item?.inventory_management?.serial_number || '-'}</u>
                </span>
            ),
            "User": item?.inventory_management?.student_inventory?.student?.device_user_first_name ?
                (
                    <u onClick={(e) => {
                        setUserid(item?.inventory_management?.student_inventory?.student?.id);
                        setUserModal(true);
                    }} className="cursor-pointer">
                        {item?.inventory_management?.student_inventory?.student?.device_user_first_name + ' ' + (item?.inventory_management?.student_inventory?.student?.device_user_middle_name || ' ') + ' ' + item?.inventory_management?.student_inventory?.student?.device_user_last_name || ''}
                    </u>
                ) : '-',
            "return_location": item?.return_location?.name || '-',
            "created_at": item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : "-",
            "created_by": item?.user?.first_name + ' ' + item?.user?.last_name || "-",
            "parts_total": item.sub_total ? `$${formatDecimal(item.sub_total)}` : "$0",
            "Device_model": item?.inventory_management?.device_model || "-",
            "asset_tag": item?.inventory_management?.asset_tag || "-",
            "Grade": item?.inventory_management?.student_inventory?.student?.grade || "-",
            "Parent_Guardian_Email": item?.inventory_management?.student_inventory?.student?.parent_guardian_email || "-",
            "Parent_phone_number": item?.inventory_management?.student_inventory?.student?.parent_phone_number || "-",
            "Parent_guardian_name": item?.inventory_management?.student_inventory?.student?.parent_guardian_name || "-",
            "Device_complete_club": item?.inventory_management?.student_inventory?.student?.parental_coverage == "1" ? "Yes" : "No",
            "Student_num": item?.inventory_management?.student_inventory?.student?.student_num || "-",
            "batch_name": item?.batch_name || "-",
        };

        return contentMap[columnName] || null;
    }
    const handleSortClick = (item) => {
        if (item == 'asset_tag') {
            item = 'Asset_tag'
        }
        if (item !== 0) {
            if (TicketTabs.OpenTicketsTab == "active") {
                GetTickets(1, searchString.SearchForOpen, item, true)
            } else {
                GetTickets(2, searchString.SearchForAwaitingShip, item, true)
            }
        }
    };
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAllFlag(isChecked ? 1 : 0);
        if (isChecked) {
            setSelectedItems((prevSelected) => [
                ...new Set([
                    ...prevSelected, // Keep previous selections across pages/tabs
                    ...AllShipDevices.map((item) => ({ id: item.id })),
                    ...AllShipDevicesForOpen.map((item) => ({ id: item.id }))
                ])
            ]);
            setIsModal({ ...IsModal, ShowCreateBatchButton: true });
        } else {
            setSelectedIdsAll([]);
            setSelectedIdsOpen([]);
            setSelectedItems([]); // Clear all selections
            setIsModal({ ...IsModal, ShowCreateBatchButton: false });
        }
    };
    const renderTable = (gridData, selectedIds, showPagination, GridFlagg) => {
        return (
            <>

                <table className="table data-table mb-0" >
                    <thead className='GridHeader'>
                        <tr>
                            {TicketTabs.AwaitingShipTab == "active" &&
                                <th scope="col">
                                    {gridData?.length != 0 && (
                                        <input className='form-check-input' disabled={selectAllFlag == 1} type="checkbox" checked={selectedIds.length === gridData.length} onChange={(e) => handleHeaderCheckboxChange(e, GridFlagg)} />
                                    )}
                                </th>
                            }
                            {columnNames?.map((item, index) => {
                                const columnName = item.replace(/_/g, ' ');
                                const transformedName = transformNameOfCol(columnName);
                                if (!transformedName) return null;
                                return (
                                    item == "Serial_number" || item == 'User' || item == "asset_tag" || item == "Device_model" || item == "Student_num" || item == "Grade" || item == 'ticket_num' ?
                                        <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}`} onClick={() => handleSortClick(item)}>
                                            {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                            <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                            {index == columnNames.length - 1 &&
                                                <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2" title='Customize Headers' style={{ height: '25px', marginRight: '20px' }} onClick={(e) => setCustomizationModal(true)} />
                                            }
                                        </th>
                                        :
                                        <th key={item} scope="col" className='fw-600'>
                                            {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                            {index == columnNames.length - 1 &&
                                                <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2" title='Customize Headers' style={{ height: '25px', marginRight: '20px' }} onClick={(e) => setCustomizationModal(true)} />
                                            }
                                        </th>
                                );
                            })}
                        </tr>

                    </thead>
                    <tbody>
                        {gridData.length != 0 ? (
                            gridData.map((item, i) => {
                                return (
                                    <tr key={i} className={`OddEvenClass tableBorderHide`}>
                                        {TicketTabs.AwaitingShipTab == "active" &&
                                            <td className="py-12">
                                                <input className='form-check-input' disabled={selectAllFlag == 1} type="checkbox" checked={selectedIds.includes(item.id)} onChange={(e) => handleCheckboxChange(e, GridFlagg, item.id)} ticketid={item.id} />
                                            </td>
                                        }
                                        {columnNames?.map(header => (
                                            <td className="py-12" key={header}>  {renderContentForColumn(header, item)}</td>
                                        ))}
                                        <td></td>
                                    </tr>
                                )
                            }))
                            :
                            <tr><td colSpan={15} className="p-3 text-center">  No Record Found</td></tr>
                        }
                    </tbody>
                </table>
                {showPagination && (
                    <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination}
                        onChange={(e) => {
                            setCurrentPage(e);

                            if (selectAllFlag) {
                                setSelectedItems((prevSelected) => [
                                    ...new Set([
                                        ...prevSelected, // Preserve previous selections from all pages
                                        ...AllShipDevices.map((item) => ({ id: item.id })),
                                        ...AllShipDevicesForOpen.map((item) => ({ id: item.id }))
                                    ])
                                ]);
                            }
                        }}
                        color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                        itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                )}
            </>
        );
    };
    function handleSearchChange(e) {
        const isActiveTab = TicketTabs.OpenTicketsTab == "active";
        const searchValue = e.target.value;
        setCurrentPage(1);
        GetTickets(isActiveTab ? 1 : 2, searchValue, TicketTabs.sortbykey, false);

        setSearchString(prevState => ({
            ...prevState,
            [isActiveTab ? 'SearchForOpen' : 'SearchForAwaitingShip']: searchValue
        }));
    }
    function handleTabClick(tabType) {
        const isAwaiting = tabType == 'awaiting';
        const ticketType = isAwaiting ? 2 : 1;
        const searchValue = isAwaiting ? searchString.SearchForAwaitingShip : searchString.SearchForOpen;
        const newTicketTabs = {
            ...TicketTabs,
            Schoolflag: isAwaiting ? 1 : 2,
            OpenTicketsTab: isAwaiting ? "" : "active",
            AwaitingShipTab: isAwaiting ? "active" : ""
        };
        const newSearchString = {
            ...searchString,
            SearchForOpen: '',
            SearchForAwaitingShip: ''
        };
        setCurrentPage(1)
        GetTickets(ticketType, searchValue, TicketTabs.sortbykey, false);
        setTicketTabs(newTicketTabs);
        setSearchString(newSearchString);
    }
    async function handleAddMoreDevices() {
        if (SelectedItems.length == 0) {
            setAlerts(<AlertsComp show={true} variant="danger" msg={"Select at least one device."} />);
            setTimeout(() => {
                setAlerts(<AlertsComp show={false} />)
            }, 3500);
            return;
        }
        setLoading(true);
        var raw = JSON.stringify({
            trackingNumber: addMoreDeviceTrackingNum || null,
            schoolId: LogInSchoolID,
            batchId: addMoreDeviceBatchId,
            batchFlag: addMoreDeviceBatchFlag,
            loginUserId: LogInUserID,
            ticketIds: SelectedItems
        })
        await ApiPostCall("/schools/batches/edit", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                        navigate('/outgoing-batches');
                    }, 3500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 3500);
                }
            }
        });

    }

    const modalBody = (
        <>
            <label>Would you like to set a default shipping method for new batches?</label>
            <div className='col-md-12 mt-3 d-flex align-items-center'>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name='DefaultShipMethod'
                        onChange={(e) => setDefaultShipMethod(1)}
                        checked={defaultShipMethod == 1}
                        id='Fedex'
                    />
                    <label className="form-check-label" htmlFor='Fedex'>FedEx</label>
                </div>
                <div className="form-check ms-5">
                    <input
                        className="form-check-input"
                        type="radio"
                        name='DefaultShipMethod'
                        onChange={(e) => setDefaultShipMethod(2)}
                        checked={defaultShipMethod == 2}
                        id='Ups'
                    />
                    <label className="form-check-label" htmlFor='Ups'>UPS</label>
                </div>
                <div className="form-check ms-5">
                    <input
                        className="form-check-input"
                        type="radio"
                        name='DefaultShipMethod'
                        onChange={(e) => setDefaultShipMethod(3)}
                        checked={defaultShipMethod == 3}
                        id='Usps'
                    />
                    <label className="form-check-label" htmlFor='Usps'>USPS</label>
                </div>

            </div>
        </>
    )

    return (
        <React.Fragment>
            {Alerts}
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Ship Devices"} handleSearch={handleSearchChange}
                loading={loading} showsearch={true} />
            <section>
                <div className="GridBox p-3 mt-2">
                    <div className='row align-items-center'>
                        <div className="col-md-6 px-0">
                            <ul className="nav nav-tabs px-3">
                                <Tab isActive={TicketTabs.AwaitingShipTab == 'active'}
                                    label="Open Tickets" onClick={() => handleTabClick('awaiting')} col={'col-md-5'} />
                                <Tab isActive={TicketTabs.OpenTicketsTab == 'active'}
                                    label="Batched Tickets" onClick={() => handleTabClick('open')} col={'col-md-5'} />
                            </ul>
                        </div>
                        <div className="col-md-6 d-flex justify-content-end">
                            <label className="font-14 pt-1 pe-3" style={{ color: 'black', cursor: 'pointer' }} onClick={(e) => navigate("/outgoing-batches")}><u> Created Batches</u></label>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            {(selectedIdsOpen.length > 0 || selectedIdsAll.length > 0) && TicketTabs.AwaitingShipTab == "active" &&
                                <div className="col-12 fw-600 pt-2 ps-3">
                                    <input className="form-check-input cursor-pointer mt-1 me-2" type="checkbox" name="selectall"
                                        checked={selectAllFlag == 1} onChange={handleSelectAll} />
                                    Select All Open Tickets Devices
                                </div>
                            }
                        </div>
                        <div className="col-md-8 text-end">
                            {addMoreDeviceBatchId && TicketTabs.AwaitingShipTab == 'active' && (
                                <label className="BorderBtn ms-3 text-center" onClick={handleAddMoreDevices}> Add devices into batch
                                    <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                                </label>
                            )}
                            {TicketTabs.AwaitingShipTab == 'active' && IsModal.ShowCreateBatchButton == true && (
                                <label className="BorderBtn ms-3 text-center" onClick={(e) => setIsModal({ ...IsModal, createbatch: true })}> Create Batch
                                    <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                                </label>
                            )}
                            {!hasRoleAccess(effectiveRole, RoleEnum.ONLY_TECH) && schoolDetail == 2 && (
                                <label className="SaveBtn ms-3 text-center" onClick={() => {
                                    setDefaultShipMethod(UserData.defaultShipMethod);
                                    setDefautCarrierPopup(true);
                                }}> Set Default Carrier </label>
                            )}
                        </div>
                    </div>
                    <div className="greyBox p-3 mt-3">
                        <div className="row px-3">

                            <div className="greyBox py-0">

                                <div className="Header row align-items-center">
                                    <div className="col-12 data-table-container">
                                        {TicketTabs.AwaitingShipTab == 'active' ? (
                                            <>{renderTable(AllShipDevices, selectedIdsAll, showPagination, "all")}</>
                                        ) : TicketTabs.OpenTicketsTab == 'active' ? (
                                            <>{renderTable(AllShipDevicesForOpen, selectedIdsOpen, showPagination1, "open")}</>
                                        ) : null}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {IsModal.TicketPopup && <TicketDetailsPopup isShow={IsModal.TicketPopup} ticketid={IsModal.TicketID} inventoryid={IsModal.DeviceID} ClosePopup={(e) => setIsModal({ ...IsModal, TicketPopup: false })} />}
            {IsModal.DevicePopup && <DeviceDetailsPopup Showbuttons={1} ticketid={IsModal.TicketID} createticketbutton={true} deviceid={IsModal.DeviceID} activetab="device" isShow={IsModal.DevicePopup} ClosePopup={(e) => setIsModal({ ...IsModal, DevicePopup: false })} />}
            {IsModal.createbatch && <CreateShippingCom SelectedItems={SelectedItems} schoolname={schoolname}
                AllShipDevices={AllShipDevices} setAllShipDevices={setAllShipDevices}
                ClosePopup={(e) => setIsModal({ ...IsModal, createbatch: false })} isShow={IsModal.createbatch}
                shippingFlag={1} GetTickets={GetTickets} action={(e) => setIsModal({ ...IsModal, createbatch: false, ShowCreateBatchButton: false })}
                setSelectedIdsAll={setSelectedIdsAll} setSelectedIdsOpen={setSelectedIdsOpen}
                ActiveTab={(e) => setTicketTabs({ ...TicketTabs, AwaitingShipTab: 'active', OpenTicketsTab: '' })}
                HideBtn={(e) => setIsModal({ ...IsModal, createbatch: false, ShowCreateBatchButton: false })}
                setSelectAllFlag={setSelectAllFlag} selectAllFlag={selectAllFlag}
            />}
            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Ship Devices'} GetCall={() => ApiGetHeaders(14, setColumnNames)} />}
            {UserModal && <UserDetailsPopup isShow={UserModal} ClosePopup={(e) => setUserModal(false)} userid={Userid} />}

            <Popup isshow={defaultCarrierPopup} size={"md"} title={"Set Default Carrier"}
                closePopup={() => {
                    setDefaultShipMethod(UserData.defaultShipMethod);
                    setDefautCarrierPopup(false);
                }}
                modalBody={modalBody}
                visibleSaveBtn={true} btnText={"Confirm"} handleSave={async () => {
                    await DefaultShipMethodCall(LogInSchoolID, defaultShipMethod, setLoading, setAlerts);
                    setDefautCarrierPopup(false);
                }} />
        </React.Fragment >
    )
}
